import React, { Component } from 'react';
import mobx, { observable } from 'mobx';
import { inject, observer, autorun } from 'mobx-react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button, Modal, ModalHeader, ModalFooter } from 'react-bootstrap';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import moment from 'moment';
import appConfig from 'react-global-configuration';
import Cons from '../../isomorphic/cons';
import primeHelper from '../utils/prime-helper';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import TokenEdit from '../shared/token-edit';
import PropTypes from 'prop-types';
import _ from 'lodash';
import AnalyticsResource from '../resources/analytics-resource';

const AsyncTypeahead = asyncContainer(Typeahead);
const AsyncTypeaheadProperty = asyncContainer(Typeahead);

@inject('appStore')
@observer
class RefWrappedTypeAhead extends Component {
    // Thse refwrapper classes are to allow the TypeAheads that are rendered as part of the header filter to
    // have a working ref value
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Typeahead
                ref={(x) => {
                    {
                        appStore.viewStore[this.props.refName] = x;
                    }
                }}
                {...this.props}
            />
        );
    }
}

RefWrappedTypeAhead.propTypes = {
    refName: PropTypes.string,
};

@inject('appStore')
@observer
class RefWrappedAsyncTypeAhead extends Component {
    constructor(props) {
        super(props);
        this.TA = asyncContainer(Typeahead);
    }

    render() {
        const { TA } = this;
        return (
            <TA
                ref={(x) => {
                    {
                        appStore.viewStore[this.props.refName] = x;
                    }
                }}
                {...this.props}
            />
        );
    }
}

RefWrappedAsyncTypeAhead.propTypes = {
    refName: PropTypes.string,
};

@inject('appStore')
@observer
class AgentLookupTypeAhead extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        // injecting the stores so that the control will rerender.  Could not get it to work anyother way
        // love to see it done without this wrapper and passing in the store
        return <RefWrappedAsyncTypeAhead options={appStore.tcFileStore.lookupAgentsComputed} {...this.props} />;
    }
}

@inject('appStore')
@observer
class CoordinatorLookupTypeAhead extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        // tried to pass in options and it didnt work.  making these two for the time being
        return (
            <RefWrappedAsyncTypeAhead options={appStore.coordinatorStore.lookupCoordinatorsComputed} {...this.props} />
        );
    }
}


@inject('appStore')
@observer
class SubscriberNameLookupTypeAhead extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <RefWrappedAsyncTypeAhead options={appStore.tcFileStore.lookupSubcribersComputed} {...this.props} />
        );
    }
}

@inject('appStore')
@observer
class PropertyAddressLookupTypeAhead extends Component {
    constructor(props) {
        super(props);
        this.TA = asyncContainer(Typeahead);
    }

    render() {
        const { TA } = this;
        // tried to pass in options and it didnt work.  making PropertyAddressLookupTypeAhead and
        // the CoordinatorLookupTypeAhead for the time being
        return <TA options={appStore.tcFileStore.lookupTcFilesComputed || []} {...this.props} />;
    }
}

@inject('appStore')
@observer
export default class TcFileView extends Component {
    constructor(props) {
        super(props);
    }

    onRowSelect(tcFile, rows) {
        primeHelper.logIntoPropertyFile(tcFile, appStore.viewStore.selectedTab);
    }

    selectRowProp = {
        mode: 'checkbox',
        clickToSelect: true,
        hideSelectColumn: true,
        onSelect: this.onRowSelect,
    };

    renderAgentItem = (option, props, index) => {
        return (
            <div key={option.agentContactId}>
                <span>{`${option.name} - ${option.email}`}</span>
            </div>
        );
    };

    renderCoordinatorItem = (option, props, index) => {
        return (
            <div key={option.coordinatorId}>
                <span>{`${option.name} - ${option.email}`}</span>
            </div>
        );
    };

    renderSubscriberNameItem = (option, props, index) => {
        return (
            <div key={option.subscribernameid}>
                <span>{`${option.subscribername}`}</span>
            </div>
        );
    };

    renderAddressItem(option, props, index) {
        return (
            <div key={option.id} data-fileid={option.TransactionId ? option.TransactionId : option.ListingId}>
                <span>
                    {option.PropertyAddress} - {option.AgentName}-{' '}
                    {option.TransactionId > 0 ? 'Transaction' : 'Listing'}
                </span>
            </div>
        );
    }

    handleTypeOfSale = (type) => {
        if (type === 'sale') return 'Sale';
        else if (type === 'listing_gone_pending') return 'Listing Gone Pending';
        else if (type === 'doubled_ended') return 'Double-Ended';
        else if (type === 'lease_listing') return 'Lease Listing';
        else if (type === 'listing') return 'Listing';
        else if (type === 'lease') return 'Lease';
        return;
    };

    renderTcFileItem(option, props, index) {
        return (
            <div key={option.tcFileId}>
                <button
                    style={{ marginRight: '10px' }}
                    className="btn btn-default btn-sm"
                    onClick={this.handleSkySlopeButtonClick.bind(this, option)}
                >
                    SkySlope
                </button>
                <span style={{ marginRight: '10px' }}>{option.propertyAddress}</span>
                <span className="label label-default" style={{ marginRight: '10px' }}>
                    {this.handleTypeOfSale(option.typeOfSale)}
                </span>
                {this.renderStatusSpan(option.status)}
            </div>
        );
    }

    renderStatusSpan(status) {
        return <span className={`label label-${status}`}>{status}</span>;
    }

    handleSkySlopeButtonClick(tcFile, e) {
        e.stopPropagation();

        primeHelper.logIntoPropertyFile(tcFile, appStore.viewStore.selectedTab);
    }

    onFileTableSortChange(name, order) {
        setTimeout(() => {
            appStore.viewStore.updateFileTableSort(name, order);
            this.refs.table.store.setSortInfo(
                appStore.viewStore.fileTableViewOptions.sortOrder.slice(),
                appStore.viewStore.fileTableViewOptions.sortName.slice()
            );
        });
    }

    sizePerPageListChange(pageSize) {
        appStore.viewStore.fileTableViewOptions.pageSize = pageSize;
    }

    onPageChange(page) {
        appStore.viewStore.fileTableViewOptions.currentPage = page;
    }

    lookupAgentsSelected(selectedAgent) {
        const agent = selectedAgent[0];
        if (agent) {
            const newFilter = {
                label: `${agent.name}`,
                type: 'agent',
                filter: { agentContactId: agent.agentContactId },
            };
            appStore.viewStore.setFilepageFilter(newFilter);
            appStore.viewStore._agentTypeAhead.getInstance().clear();
        }
    }

    getAgentsFilter() {
        return (
            <AgentLookupTypeAhead
                appStore={appStore}
                multiple
                labelKey="name"
                minLength={2}
                onSearch={appStore.tcFileStore.loadLookupAgents}
                renderMenuItemChildren={this.renderAgentItem}
                onChange={this.lookupAgentsSelected.bind(this)}
                refName="_agentTypeAhead"
            />
        );
    }

    lookupSubscriberNameSelected(subscriberName) {
        const sn = subscriberName[0];
        if (sn) {
            const newFilter = {
                label: `${sn.subscribername}`,
                type: 'Brokerage',
                filter: { where: { subscriberName: sn.subscribername } },
            };
            appStore.viewStore.setFilepageFilter(newFilter);
            setTimeout(() => appStore.viewStore._subscriberNameTypeAhead.getInstance().clear(), 0);
        }
    }
    
    getSubscriberNameFilter() {
        return (
            <SubscriberNameLookupTypeAhead
                appStore={appStore}
                multiple
                labelKey="subscribername"
                minLength={3}
                onSearch={appStore.tcFileStore.loadLookupSubscriberName}
                renderMenuItemChildren={this.renderSubscriberNameItem} 
                onChange={this.lookupSubscriberNameSelected.bind(this)}
                refName="_subscriberNameTypeAhead"
            />
        );
    }

    lookupCoordinatorsSelected(selectedCoordinator) {
        const tc = selectedCoordinator[0];
        if (tc) {
            const newFilter = {
                label: `${tc.name}`,
                type: 'tc',
                filter: { where: { coordinatorId: tc.coordinatorId } },
            };
            appStore.viewStore.setFilepageFilter(newFilter);
            setTimeout(() => appStore.viewStore._coordinatorTypeAhead.getInstance().clear(), 0);
        }
    }

    getCoordinatorsFilter() {
        return (
            <CoordinatorLookupTypeAhead
                appStore={appStore}
                multiple
                labelKey="name"
                minLength={3}
                onSearch={appStore.coordinatorStore.loadLookupCoordinators}
                renderMenuItemChildren={this.renderCoordinatorItem}
                onChange={this.lookupCoordinatorsSelected.bind(this)}
                refName="_coordinatorTypeAhead"
            />
        );
    }

    lookupStatusSelected(selectedStatus) {
        const status = selectedStatus[0];
        if (status) {
            const newFilter = { label: `${status.name}`, type: 'status', filter: { where: { status: status.value } } };
            appStore.viewStore.setFilepageFilter(newFilter);
            appStore.viewStore._statusTypeAhead.getInstance().clear();
        }
    }

    getStatusFilter() {
        return (
            <RefWrappedTypeAhead
                appStore={appStore}
                multiple
                labelKey="name"
                options={_.map(Cons.fileStatuses, (value, key) => {
                    return { name: key, value: value };
                })}
                onChange={this.lookupStatusSelected.bind(this)}
                refName="_statusTypeAhead"
            />
        );
    }

    lookupFileSelected(selectedFiles) {
        // appStore.analytics.track("File Property Address Search Selected", {selectedFile: selectedFiles})
        appStore.viewStore.openFileDetailPageById(selectedFiles[0].tcFileId);
    }

    onModalEntered() {
        this._addressTypeahead.getInstance().focus();
    }

    editButtonFormatter(_, tcFile) {
        return (
            <button className="btn btn-default btn-sm" onClick={this.handleEditButtonClick.bind(this, tcFile)}>
                Edit
            </button>
        );
    }

    handleEditButtonClick(tcFile, e) {
        e.stopPropagation();
        appStore.viewStore.openFileDetailPageById(tcFile.tcFileId);
    }

    formatDate(cell, row) {
        return cell ? moment(cell).format('L LT') : '';
    }

    handleFilterRemoveClick(option) {
        appStore.viewStore.removeFilepageFilter(option.key);
    }

    rowClassNameFormat(model) {
        return model.showEscrowWarning ? 'td-row-danger' : '';
    }

    renderMultipleFilesErrors() {
        if (appStore.tcFileStore.duplicateFiles.length > 0) {
            const model = _.first(appStore.tcFileStore.duplicateFiles);

            return (
                <p className="form-error">
                    This SkySlope file is already assigned to&nbsp;
                    <strong>{model.coordinator.name}</strong>.
                </p>
            );
        }

        return null;
    }

    render() {
        const fileTableOptions = {
            sortName: appStore.viewStore.fileTableViewOptions.sortNameArray,
            sortOrder: appStore.viewStore.fileTableViewOptions.sortOrderArray,
            onSortChange: this.onFileTableSortChange.bind(this),
            onSizePerPageList: this.sizePerPageListChange.bind(this),
            onPageChange: this.onPageChange.bind(this),
            page: 1, // which page you want to show as default
            sizePerPageList: [
                {
                    text: '5',
                    value: 5,
                },
                {
                    text: '10',
                    value: 10,
                },
                {
                    text: '25',
                    value: 25,
                },
                {
                    text: '50',
                    value: 50,
                },
            ], // you can change the dropdown list for size per page
            sizePerPage: appStore.viewStore.fileTableViewOptions.pageSize, // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3, // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationShowsTotal: true, // Accept bool or function
            paginationPosition: 'bottom', // default is bottom, top and both is all available
            // hideSizePerPage: true > You can hide the dropdown for sizePerPage
            // alwaysShowAllBtns: true // Always show next and previous button
            // withFirstAndLast: false > Hide the going to First and Last page button
        };
        window.table = this.refs.table;
        return (
            <div className="tab-pane active file-view">
                <Modal
                    show={appStore.viewStore.addFileDialogOpen}
                    onHide={appStore.viewStore.hideAddFileDialog}
                    onEntered={this.onModalEntered.bind(this)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-lg">Create New File</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="new-file-modal">
                        <div className="row">
                            <div className="col col-xs-12 col-md-6 col-lg-6 ">
                                <Button
                                    className="btn-primary btn-block"
                                    onClick={() => {
                                        this.props.appStore.analytics.trackFileAction(
                                            null,
                                            `CREATE_${Cons.saleTypes['Listing']}`
                                        );
                                        this.props.appStore.viewStore.openAddListingToPrimePage(
                                            Cons.saleTypes['Listing']
                                        );
                                    }}
                                >
                                    Create New Listing
                                </Button>
                            </div>
                            <div className="col col-xs-12 col-md-6 col-lg-6 ">
                                <Button
                                    className="btn-primary btn-block"
                                    onClick={() => {
                                        this.props.appStore.analytics.trackFileAction(
                                            null,
                                            `CREATE_${Cons.saleTypes['Listing Gone Pending']}`
                                        );
                                        this.props.appStore.viewStore.openAddListingToPrimePage(
                                            Cons.saleTypes['Listing Gone Pending']
                                        );
                                    }}
                                >
                                    Create New Listing Gone Pending
                                </Button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col col-xs-12 col-md-6 col-lg-6 ">
                                <Button
                                    className="btn-primary btn-block"
                                    onClick={() => {
                                        this.props.appStore.analytics.trackFileAction(
                                            null,
                                            `CREATE_${Cons.saleTypes['Double Ended']}`
                                        );
                                        this.props.appStore.viewStore.openAddListingToPrimePage(
                                            Cons.saleTypes['Double Ended']
                                        );
                                    }}
                                >
                                    Create New Double Ended Transaction
                                </Button>
                            </div>
                            <div className="col col-xs-12 col-md-6 col-lg-6 ">
                                <Button
                                    className="btn-primary btn-block"
                                    onClick={() => {
                                        this.props.appStore.analytics.trackFileAction(
                                            null,
                                            `CREATE_${Cons.saleTypes['Sale']}`
                                        );
                                        this.props.appStore.viewStore.openAddTransactionToPrimePage(
                                            Cons.saleTypes['Sale']
                                        );
                                    }}
                                >
                                    Create New Sale
                                </Button>
                            </div>
                        </div>
                        <div className="row text-center">
                            <div className="col col-xs-12 col-md-12 col-lg-12 ">OR</div>
                        </div>
                        <div className="row">
                            <div className="col col-xs-12 col-md-12 col-lg-12 form-group ">
                                <AsyncTypeaheadProperty
                                    labelKey="PropertyAddress"
                                    placeholder="Find existing file in SkySlope..."
                                    minLength={3}
                                    options={appStore.addressLookupStore.addressesArray}
                                    onSearch={appStore.addressLookupStore.loadAddresses}
                                    renderMenuItemChildren={this.renderAddressItem}
                                    onChange={appStore.tcFileStore.addFileAddressSelected}
                                    filterBy={
                                        () => {
                                            return true;
                                        } /* just return the results rom elastic search */
                                    }
                                    ref={(el) => {
                                        this._addressTypeahead = el;
                                    }}
                                ></AsyncTypeaheadProperty>
                            </div>
                            <div className="col col-xs-12 col-sm-12">{this.renderMultipleFilesErrors()}</div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
                <div className="row form-group">
                    <div className="col-sm-10">
                        <PropertyAddressLookupTypeAhead
                            appStore={appStore}
                            labelKey="propertyAddress"
                            placeholder="Search property address"
                            minLength={2}
                            onSearch={appStore.tcFileStore.loadLookupTcFiles}
                            renderMenuItemChildren={this.renderTcFileItem.bind(this)}
                            onChange={this.lookupFileSelected}
                        ></PropertyAddressLookupTypeAhead>
                    </div>
                    <div className="col-sm-2">
                        <Button
                            bsStyle="primary"
                            className="btn-block"
                            onClick={() => {
                                this.props.appStore.analytics.trackFileAction(null, 'create');
                                this.props.appStore.viewStore.showAddFileDialog();
                            }}
                        >
                            Create New File
                        </Button>
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-sm-12">
                        <TokenEdit
                            values={appStore.viewStore.fileTableViewOptions.filtersKP}
                            onRemove={this.handleFilterRemoveClick}
                        ></TokenEdit>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 fill">
                        <BootstrapTable
                            ref="table"
                            fetchInfo={{ dataTotalSize: appStore.tcFileStore.filesCount }}
                            data={appStore.tcFileStore.files.values()}
                            remote={true}
                            selectRow={this.selectRowProp}
                            options={fileTableOptions}
                            multiColumnSort={5}
                            trClassName={this.rowClassNameFormat}
                            hover
                            pagination={true}
                        >
                            <TableHeaderColumn dataField="tcFileId" isKey dataAlign="right" dataSort hidden>
                                tcFileId
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField="propertyAddress" dataSort>
                                Address
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="agents"
                                dataFormat={(cell, row) => (cell ? cell.map((agent) => agent.name).join(', ') : '')}
                                filter={{
                                    type: 'CustomFilter',
                                    getElement: this.getAgentsFilter.bind(this),
                                }}
                            >
                                Agent
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="status"
                                width="90px"
                                dataFormat={this.renderStatusSpan}
                                dataAlign="center"
                                filter={{
                                    type: 'CustomFilter',
                                    getElement: this.getStatusFilter.bind(this),
                                }}
                                dataSort
                            >
                                Status
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="coordinator"
                                dataFormat={(cell, row) => cell.name}
                                filter={{
                                    type: 'CustomFilter',
                                    getElement: this.getCoordinatorsFilter.bind(this),
                                }}
                                ref="zzzzzzzz"
                            >
                                TC
                            </TableHeaderColumn>
                            <TableHeaderColumn 
                                dataField="subscriberName" 
                                dataSort
                                filter={{
                                    type: 'CustomFilter',
                                    getElement: this.getSubscriberNameFilter.bind(this),
                                    delay: 800
                                }}
                            >
                                Brokerage
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="fileSubmissionDate"
                                dataFormat={this.formatDate.bind(this)}
                                dataSort
                            >
                                Submission Date
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataField="estimatedCloseDate"
                                dataFormat={this.formatDate.bind(this)}
                                dataSort
                            >
                                Close of Escrow
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                dataFormat={this.editButtonFormatter.bind(this)}
                                width="70px"
                                dataAlign="center"
                            ></TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/files/tcfile-view.js